<template>
  <div
    class="back-to-top"
    v-on:click="backToTop"
    v-bind:class="showHide"
  >
    <simple-svg
      :filepath="'/static/svg/arrow-up.svg'"
      :fill="'#fff'"
      :width="'14px'"
      :height="'38px'"
    />
  </div>
</template>

<script>
import { TweenLite } from 'gsap'
// eslint-disable-next-line
import ScrollToPlugin from 'gsap/ScrollToPlugin'

export default {
  name: 'BackToTop',
  data () {
    return {
      showHide: ''
    }
  },
  methods: {
    backToTop: function () {
      TweenLite.to(window, 1, {
        scrollTo: 0
      })
    },
    showArrow: function () {
      var y = window.scrollY

      if (y >= 200) {
        this.showHide = 'active'
      } else {
        this.showHide = ''
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.showArrow)
  },
  destroyed () {
    window.removeEventListener('scroll', this.showArrow)
  }
}
</script>

<style lang="scss" scoped>

@import '../styles/core/vars.scss';
@import '../styles/core/mixins.scss';

.back-to-top {
  display: block;
  position: fixed;
  bottom: 10px;
  left: 10px;
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease-in-out;

  &.active {
    opacity: 1;
    pointer-events: auto;
  }

  @include respond-to('medium') {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/BackToTop.vue